import * as R from 'ramda/src/index';
import {unescape} from 'lodash';
import {PUBLISH, replaceCmsUrl} from 'cms/helpers/common';

const CATEGORY = 'Faq Category';
const COMPANY = 'Faq Company';

const getCategories = R.pipe(
  R.filter(({template, post_status}) => ([CATEGORY, COMPANY].includes(template) && post_status === PUBLISH)),
  R.map(R.pick(['ID', 'post_title', 'permanlink', 'image', 'countArticles'])),
  R.map((item) => ({
    ...item,
    permanlink: replaceCmsUrl(item.permanlink),
    post_title: unescape(item.post_title)
  }))
);

export {
  getCategories  
};
